module.exports = __webpack_public_path__ + "img/36.32347625.jpg";